export const IconManager = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M17.138 6.918a5.139 5.139 0 1 1-10.278-.02 5.139 5.139 0 0 1 10.278.02M10.082 20.94l.847-3.597c.127-.54.248-1.081.384-1.619a.53.53 0 0 0-.057-.434c-.392-.667-.77-1.341-1.165-2.035h3.836c-.371.648-.72 1.278-1.092 1.899a.86.86 0 0 0-.11.695c.393 1.608.764 3.221 1.144 4.83.015.065.038.13.07.238l.64-2.57c.404-1.616.812-3.232 1.206-4.85.045-.18.103-.228.288-.212a5.38 5.38 0 0 1 4.761 4.043c.123.525.178 1.064.163 1.603v1.31c-.014 1.143-.836 1.982-1.979 1.984q-7.008.009-14.017 0c-1.066 0-1.898-.733-1.96-1.777-.05-.937-.081-1.88.075-2.817.338-2.026 2.104-3.847 4.118-4.23q.364-.075.733-.113c.164-.014.217.033.255.189q.704 2.863 1.425 5.721c.135.558.28 1.119.435 1.741" />
    </svg>
  );
};
